import React from 'react';
import PropTypes from 'prop-types';
import { Popover, OverlayTrigger } from 'react-bootstrap';
import sortBy from 'lodash/sortBy';
import styles from './OutletCell.css';

class OutletCell extends React.Component {
  render() {
    const { outlets: outletsProps, allOutlet } = this.props;
    const outlets =
      outletsProps === undefined ? [] : sortBy(outletsProps, ['name']);
    const popover = (
      <Popover title="Assigned Outlets" bsClass={`${styles.popover} popover`}>
        <ul>
          {outlets.map(o => {
            return (
              <li key={o.id} className={styles['popover-outlet-name']}>
                &bull; {o.name}
              </li>
            );
          })}
        </ul>
      </Popover>
    );
    if (outlets.length === 0) {
      return <span className={styles['outlet-name']}>-</span>;
    }
    if (outlets.length === 1) {
      return <span className={styles['outlet-name']}>{outlets[0].name}</span>;
    }
    if (allOutlet) {
      return (
        <OverlayTrigger placement="top" overlay={popover}>
          <button className="btn btn-info">All Outlets</button>
        </OverlayTrigger>
      );
    }
    return (
      <OverlayTrigger placement="top" overlay={popover}>
        <button className="btn btn-success">{outlets.length} Outlet(s)</button>
      </OverlayTrigger>
    );
  }
}

OutletCell.PropTypes = {
  outlets: PropTypes.array,
  allOutlet: PropTypes.boolean,
};

export default OutletCell;
